<template>
  <!-- 左侧菜单组件 -->
  <el-container :class="{ collapsewidth: isCollapse }">
    <el-header height="50px">
      <!-- logo组件 -->
      <lo-go :collapse="isCollapse"></lo-go>
    </el-header>
    <el-main>
      <!-- 菜单 -->
      <el-menu
        :default-active="activeMenu"
        class="el-menu-vertical-demo"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409eff"
        router
        :collapse="isCollapse"
      >
        <side-bar
          v-for="route in permission_routes"
          :key="route.path"
          :item="route"
          :basePath="route.path"
        ></side-bar>
      </el-menu>
    </el-main>
  </el-container>
</template>
<script>
import LoGo from "./logo";
import SideBar from "./sidebar";
import { mapGetters } from "vuex";
export default {
  name: "MenuBar",
  components: { LoGo, SideBar },
  data() {
    return {
      menu: []
    };
  },
  created() {
    this.$store.dispatch("generateRoutes");
    this.getrolemenu();
  },
  methods: {
    /*
     **  @description 获取菜单权限
     **  @param {}
     **  @return
     **  @author shipingan
     */
    getrolemenu() {
      let url = "/dapi/u/selectMenuIdByUid";
      let params = {
        uid: this.userinfo.uid
      };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.menu = JSON.parse(data.data.menu_id); //获取到role菜单数据
          if (this.menu.includes("accessanomaly")) {
            this.$router.push("accessanomaly");
          }
          this.setMenuRole();
        }
      });
    },
    /*
     **  @description 设置菜单role
     **  @param {}
     **  @return
     **  @author shipingan
     */
    setMenuRole() {
      let routes = this.permission_routes; //全部路由
      routes.map(item => {
        //先判断父级需要显示不
        if (item.name != undefined) {
          if (this.menu.indexOf(item.name) > -1) {
            item.meta.role = true;
          }
        }
        //判断children
        if (item.children != undefined) {
          let arr = item.children;
          arr.map(key => {
            if (this.menu.indexOf(key.name) > -1) {
              key.meta.role = true;
              //因为上传的菜单数据不会把父级传上去，所以父级不显示，做个判断加上父级的权限显示
              if (item.meta != undefined) {
                item.meta.role = true;
              }
            }
          });
        }
      });
    }
  },
  computed: {
    ...mapGetters(["permission_routes", "isCollapse", "userinfo"]),
    activeMenu() {
      const { meta, path } = this.$route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    }
  }
};
</script>
<style lang="less" scoped>
.el-container {
  .el-header {
    padding: 0;
  }
  .collapsewidth {
    width: 64px;
  }
  .el-main {
    padding: 0;
    .el-menu {
      height: 100%;
      text-align: left;
      border: none;
    }
  }
}
</style>
